<!-- src/apps/workspace/dashboard/DashboardMain.vue -->

<script setup lang="ts">
  import DashboardIndex from './DashboardIndex.vue';
</script>

<template>
  <DashboardIndex />
</template>
